/* Keep plugin lookups associated with their native APEX field labels. */
(function (window, document) {
    'use strict';
    var lx = window.lx = window.lx || {};
    if (lx.lookupLabels) return;

    function nativeLabel(item) {
        return document.getElementById(item.id + '_LABEL') || document.querySelector('label[for="' + item.id + '"]');
    }
    function decorate(item) {
        var label = nativeLabel(item), container = item.nextElementSibling;
        var control = container && container.querySelector('.select2-selection[role=combobox]');
        if (!label || !control) return;
        if (!label.id) label.id = item.id + '_LABEL';
        control.setAttribute('aria-labelledby', label.id);
        var clear = control.classList.contains('select2-selection--single') &&
            control.querySelector('.select2-selection__clear');
        if (!clear) return;
        var hr = document.documentElement.lang.indexOf('hr') === 0;
        var name = (hr ? 'Ukloni odabir: ' : 'Clear ') + label.textContent.trim();
        clear.setAttribute('role', 'button');
        clear.setAttribute('aria-label', name);
        clear.setAttribute('title', name);
        clear.setAttribute('aria-disabled', item.disabled ? 'true' : 'false');
        clear.tabIndex = item.disabled ? -1 : 0;
        if (!clear.dataset.lpLookupClearReady) {
            clear.dataset.lpLookupClearReady = 'true';
            clear.addEventListener('keydown', function (event) {
                if (event.key !== 'Enter' && event.key !== ' ') return;
                event.preventDefault();
                event.stopPropagation();
                if (item.disabled) return;
                // Select2 owns clearing, unselect prevention, change and focus.
                $(clear).trigger($.Event('mousedown', {which:1, button:0}));
            });
        }
    }
    function refresh() {
        document.querySelectorAll('select.select2-hidden-accessible[id]').forEach(decorate);
    }
    lx.lookupLabels = {refresh:refresh};
    var $ = window.apex.jQuery;
    $(refresh);
    $(document).on('apexreadyend.lpLookupLabels apexafterrefresh.lpLookupLabels', refresh)
        .on('change.lpLookupLabels select2:select.lpLookupLabels select2:unselect.lpLookupLabels',
            'select.select2-hidden-accessible[id]', function () { decorate(this); })
        .on('select2:open.lpLookupLabels', 'select.select2-hidden-accessible[id]', function () {
            decorate(this);
            var label = nativeLabel(this);
            if (!label) return;
            var hr = document.documentElement.lang.indexOf('hr') === 0;
            document.querySelectorAll('.select2-container--open .select2-search__field').forEach(function (search) {
                search.setAttribute('aria-label', (hr ? 'Pretraži: ' : 'Search ') + label.textContent.trim());
                if (!search.placeholder) search.placeholder = hr ? 'Pretraži...' : 'Search...';
            });
        });
}(window, document));
